<template>
	<div
		id="data-list-visit_point"
		class="vs-con-loading__container"
		:class="ClassCustom ? ClassCustom : 'custom-height'"
	>
		<div v-if="navbarOptions" class="vx-row">
			<div class="vx-col md:w-full">
				<label class="g-table--title" v-text="$t('VisitPointObject.AssignedVisitPoints')"></label>
			</div>
		</div>
		<div class="vx-row flex items-center">
			<div v-if="navbarOptions" class="vx-col md:w-1/5 mt-2">
				<div class="o-span--count bg-primary" v-text="assignedVisitPoints.length"></div>
			</div>
			<div v-if="navbarOptions" class="vx-col md:w-3/5 mt-2">
				<vs-dropdown vs-trigger-click class="ml-auto cursor-pointer">
					<vs-button
						type="border"
						color="#F9841E"
						style="padding: 0.3rem 2.5rem; font-size: 12px; line-height: 15px"
						icon-pack="feather"
						icon="icon-plus"
						>{{ $t("ButtonAddTypeConfig") }}
					</vs-button>
					<vs-dropdown-menu :style="{width: windowWidth > 620 ? '15%' : '50%'}">
						<vs-dropdown-item>
							<div
								@click.prevent="visitPointMounted = true"
								class="flex items-center mt-2"
								:title="$t('VisitPointObject.AssignVisitPointToltip')"
							>
								<feather-icon icon="ListIcon" class="inline-block mr-2" svgClasses="w-5 h-5" />
								<span>{{ $t("ListVisitPoint") }}</span>
							</div>
						</vs-dropdown-item>
						<vs-dropdown-item>
							<div
								@click="getAllVisitPoint"
								class="flex items-center mt-2 mb-2"
								:title="$t('VisitPointObject.AssignAllVisitPointText')"
							>
								<feather-icon icon="CheckSquareIcon" class="inline-block mr-2" svgClasses="w-5 h-5" />
								<span>{{ $t("VisitPointObject.Assig") }} {{ $t("All") }}</span>
							</div>
						</vs-dropdown-item>
					</vs-dropdown-menu>
				</vs-dropdown>
			</div>
			<div v-if="navbarOptions" class="vx-col md:w-1/5 flex justify-end mt-2">
				<vx-tooltip
					v-if="assignedVisitPointsFilter.length > 1"
					class="cursor-pointer mr-4"
					color="primary"
					position="bottom"
					:title="$t('Crud.Delete')"
					:text="$t('Alarm.DeleteAllVisitPoints')"
				>
					<feather-icon
						class="g-label--normal"
						size="small"
						icon="TrashIcon"
						svgClasses="h-5 w-5 text-danger cursor-pointer"
						@click.stop="openDeleteAllConfirm"
					/>
				</vx-tooltip>
				<vs-dropdown vs-custom-content :vs-trigger-click="false" class="cursor-pointer">
					<feather-icon
						id="btn-show-list-resources"
						class="g-label--normal"
						size="small"
						icon="LayoutIcon"
						svgClasses="h-5 w-5 text-dark cursor-pointer"
					/>
					<vs-dropdown-menu>
						<vx-card no-shadow style="width: 400px" :title="$t('VisitPointObject.Columns')">
							<p>{{ $t("VisitPointObject.ColumnsText") }}</p>
							<ul class="demo-alignment">
								<li>
									<vs-checkbox v-model="checkBoxID">ID</vs-checkbox>
								</li>
								<li>
									<vs-checkbox v-model="checkBoxName" disabled>{{ $t("Name") }}</vs-checkbox>
								</li>
								<li>
									<vs-checkbox v-model="checkBoxIdentification" disabled
										>{{ $t("Identification") }}
									</vs-checkbox>
								</li>
								<li>
									<vs-checkbox v-model="checkBoxAddress">{{ $t("Address") }}</vs-checkbox>
								</li>
								<li>
									<vs-checkbox v-model="checkBoxCity">{{ $t("City") }}</vs-checkbox>
								</li>
							</ul>
						</vx-card>
					</vs-dropdown-menu>
				</vs-dropdown>
			</div>
			<vue-perfect-scrollbar class="scroll-area" :settings="settings">
				<hr v-if="navbarOptions" class="mt-2" style="border: 0.75px solid #a3a3a3" />
				<vs-table
					v-if="assignedVisitPointsFilter.length > 0"
					pagination
					search
					:max-items="navbarOptions ? '100' : '10'"
					:maxHeight="maxHeight"
					:data="assignedVisitPointsFilter"
				>
					<div
						v-if="!navbarOptions"
						slot="header"
						class="flex flex-wrap-reverse items-center flex-grow justify-between"
					>
						<div class="flex items-center">
							<label class="g-table--title mr-2" v-text="$t('VisitPointObject.TotalVisitPoints')"></label>
							<div class="o-span--count bg-primary" v-text="assignedVisitPoints.length"></div>
						</div>
						<vs-dropdown
							vs-custom-content
							:vs-trigger-click="false"
							class="cursor-pointer"
							v-if="configColumns"
						>
							<vs-button
								class="ml-1"
								color="primary"
								type="filled"
								icon-pack="feather"
								icon="icon-layout"
							></vs-button>
							<vs-dropdown-menu :style="{width: windowWidth > 620 ? '30%' : '50%'}">
								<vx-card no-shadow :title="$t('VisitPointObject.Columns')">
									<p>{{ $t("VisitPointObject.ColumnsText") }}</p>
									<ul :class="{'demo-alignment': windowWidth > 620}">
										<li>
											<vs-checkbox v-model="checkBoxID">ID</vs-checkbox>
										</li>
										<li>
											<vs-checkbox v-model="checkBoxName" disabled>{{ $t("Name") }}</vs-checkbox>
										</li>
										<li>
											<vs-checkbox v-model="checkBoxIdentification" disabled>{{
												$t("Identification")
											}}</vs-checkbox>
										</li>
										<li>
											<vs-checkbox v-model="checkBoxAddress">{{ $t("Address") }}</vs-checkbox>
										</li>
										<li>
											<vs-checkbox v-model="checkBoxCity">{{ $t("City") }}</vs-checkbox>
										</li>
									</ul>
								</vx-card>
							</vs-dropdown-menu>
						</vs-dropdown>
					</div>
					<template slot="thead">
						<vs-th class="g-table--title">{{ $t("Action") }}</vs-th>
						<vs-th class="g-table--title" v-show="checkBoxID">ID</vs-th>
						<vs-th class="g-table--title">{{ $t("Name") }}</vs-th>
						<vs-th class="g-table--title">{{ $t("Identification") }}</vs-th>
						<vs-th class="g-table--title" v-show="checkBoxAddress">{{ $t("Address") }}</vs-th>
						<vs-th class="g-table--title" v-show="checkBoxCity">{{ $t("City") }}</vs-th>
					</template>

					<template slot-scope="{data}">
						<tbody>
							<vs-tr :key="indextr" v-for="(tr, indextr) in data">
								<vs-td class="g-table--description text-left" :data="data[indextr].id">
									<feather-icon
										v-if="navbarOptions"
										class="g-label--normal"
										size="small"
										icon="Trash2Icon"
										svgClasses="h-5 w-5 hover:text-danger cursor-pointer"
										:title="$t('Crud.Delete')"
										@click="removeAssignedVisitPoint(data[indextr].id)"
									/>
									<feather-icon
										v-else
										class="g-label--normal"
										size="small"
										icon="ExternalLinkIcon"
										svgClasses="h-5 w-5 hover:text-primary cursor-pointer"
										:title="$t('View') + ' ' + $t('Information')"
										@click="goTo(data[indextr].id)"
									/>
								</vs-td>
								<vs-td class="g-table--description" v-show="checkBoxID" :data="data[indextr].id">
									{{ data[indextr].id }}
								</vs-td>
								<vs-td class="g-table--description" :data="data[indextr].id">
									{{ data[indextr].name.toLowerCase() | capitalize }}
								</vs-td>
								<vs-td class="g-table--description" :data="data[indextr].id">
									{{ data[indextr].identification }}
								</vs-td>
								<vs-td class="g-table--description" v-show="checkBoxAddress" :data="data[indextr].id">
									{{ data[indextr].address.toLowerCase() | capitalize }}
								</vs-td>
								<vs-td class="g-table--description" v-show="checkBoxCity" :data="data[indextr].id">
									{{ data[indextr].city }}
								</vs-td>
							</vs-tr>
						</tbody>
					</template>
				</vs-table>
				<p
					v-else
					class="g-label--normal text-center mt-4"
					v-text="$t('VisitPointObject.NoAssignedVisitPoints')"
				></p>
			</vue-perfect-scrollbar>
		</div>
		<!-- VISIT POINT LIST COMPONENT -->
		<popup-customize
			class="vs-popup--content-custom"
			:fullscreen="false"
			:title="null"
			:active="visitPointMounted"
			:hidden-boolean="true"
		>
			<div class="flex items-start justify-between">
				<bread-crumbs
					:title="$t('VisitPointObject.AssignVisitPoints')"
					:subTitle="$t('VisitPointObject.AssigneVisitPointText')"
					:sizeTitle="22"
					:lineHeightTitle="27"
					:sizeSubTitle="13"
					:lineHeightSubTitle="16"
				>
				</bread-crumbs>
				<feather-icon
					icon="XIcon"
					@click.stop="visitPointMounted = false"
					class="cursor-pointer"
				></feather-icon>
			</div>
			<visit-point-list
				v-if="visitPointMounted"
				ref="VisitPointList"
				componentParent="VisitPointAssignedList"
				:customConfig="visitPointListConfig"
				:status_id="status_id"
				@showPopupVisitPointEmmit="showPopupVisitPointEmmit"
			>
				<div>
					<vs-row vs-w="12">
						<vs-col vs-justify="center" vs-align="center" vs-lg="3" vs-sm="12" vs-xs="12" class="mb-2">
							<label class="g-label">{{ $t("SearchBy") }}</label>
							<v-select
								v-model="searchField"
								:clearable="false"
								:options="searchOptions"
								name="country"
								:dir="$vs.rtl ? 'rtl' : 'ltr'"
							>
								<template v-slot:no-options="{search, searching}">
									<template v-if="searching">
										{{ $t("general.NoResultsFoundFor") + " " }}<em>{{ search }}</em>
									</template>
								</template>
							</v-select>
						</vs-col>
						<vs-col
							v-if="searchField.value === 'AdditionalFields'"
							vs-justify="center"
							vs-align="center"
							vs-lg="7"
							vs-sm="12"
							vs-xs="12"
							class="pl-2 mb-2"
						>
							<div class="vx-row">
								<div class="vx-col w-full md:w-2/3">
									<label class="g-label">{{ $t("VisitPointObject.Create.SelectObjectType") }}</label>
									<v-select
										v-model="additionalField"
										v-validate="'required'"
										name="country"
										value="typology_name"
										label="typology_name"
										:clearable="false"
										:options="additionalOptions"
										:dir="$vs.rtl ? 'rtl' : 'ltr'"
										:placeholder="$t('Select')"
									>
										<template v-slot:no-options="{search, searching}">
											<template v-if="searching">
												{{ $t("general.NoResultsFoundFor") + " " }}<em>{{ search }}</em>
											</template>
										</template>
									</v-select>
								</div>
								<div class="vx-col w-full md:w-1/3">
									<label class="vs-input--label">{{ $t("Preferences.FindExactly") }}</label>
									<vs-switch class="mt-2" color="success" v-model="exact_values" />
								</div>
							</div>
						</vs-col>
						<vs-col
							v-else
							vs-justify="center"
							vs-align="center"
							vs-lg="5"
							vs-sm="12"
							vs-xs="12"
							class="mt-6 mb-2 pl-2"
						>
							<!-- SEARCH -->
							<vs-input
								v-model="searchQuery"
								class="w-full"
								:placeholder="$t('Search')"
								@keyup.enter="searchResource"
							/>
						</vs-col>
						<vs-col
							vs-justify="center"
							vs-align="center"
							vs-lg="4"
							vs-sm="12"
							vs-xs="12"
							class="flex mt-5 mb-2"
						>
							<vs-button type="filled" class="mr-2" color="primary" @click="searchResource">
								{{ $t("Search") }}
							</vs-button>
							<vs-button
								class="mr-2"
								id="btn-locate-visit-point"
								:disabled="getCheckedVisitPoints.length <= 0"
								@click="getVisitPointSelected"
							>
								{{ $t("VisitPointObject.Assig") }}
							</vs-button>
							<vx-tooltip class="cursor-pointer" position="top" :text="$t('Crud.Update')">
								<vs-button
									type="filled"
									color="primary"
									icon-pack="feather"
									icon="icon-refresh-cw"
									:title="$t('Crud.Update')"
									@click="refres"
								></vs-button>
							</vx-tooltip>
						</vs-col>
					</vs-row>
					<dinamic-fields
						v-if="additionalField"
						ref="DinamicFields"
						:additionalFields="model"
						:additionalInfo="additional_info"
						:category="additionalField"
					></dinamic-fields>
					<vs-divider class="d-theme-border-grey-light m-0 pt-2" />
				</div>
			</visit-point-list>
		</popup-customize>
	</div>
</template>

<script>
import vSelect from "vue-select";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import VisitPointList from "@/components/visit-point/list/VisitPointList.vue";
import moduleVisitPoint from "@/store/visit-point/moduleVisitPoint.js";
import moduleCommon from "@/store/common/moduleCommon.js";
import PopupCustomize from "../../../core/components/PopupCustomize";
import {BadRequestError, ServerError, NotFoundError, NetworkError} from "@/helpers/handleErrors.js";
import DinamicFields from "../../DinamicFields/DinamicFields";
import Commons from "@/helpers/commons.js";

export default {
	props: {
		visit_point_ids: {
			type: Array,
			default: () => [],
		},
		ClassCustom: {
			type: String,
			default: "",
		},
		maxHeight: {
			type: String,
			default: "",
		},
		navbarOptions: {
			type: Boolean,
			default: true,
		},
		configColumns: {
			type: Boolean,
			default: () => true,
		},
	},
	components: {
		DinamicFields,
		PopupCustomize,
		vSelect,
		VuePerfectScrollbar,
		VisitPointList,
	},
	data() {
		return {
			settings: {
				maxScrollbarLength: 60,
				wheelSpeed: 0.6,
			},
			visitPointMounted: false,
			visitPointListConfig: {
				rowSelection: "multiple", // multiple | single
				activeCheckbox: true,
				activeHeaderCheckboxSelection: true,
				activeLink: false,
				columns: [
					"identification",
					"name",
					"address",
					"city",
					"typology_name",
					"status_name",
					"additional_info",
				],
				tableOptions: false,
				showItemsPerPage: false,
				showSearch: false,
				showActions: false,
				filterHead: false,
				cellRendererAdditionalFields: true,
			},
			searchQuery: "",
			visit_point_nav: 0,
			visit_point_selected: [],
			searchField: {value: "Name", label: this.$t("Name")},
			dataSelect: [],
			additionalField: null,
			model: null,
			additional_info: {},
			exact_values: false,
			status_id: [],
			checkBoxName: true,
			checkBoxIdentification: true,
			checkBoxAddress: true,
			checkBoxCity: false,
			checkBoxID: false,
		};
	},
	computed: {
		// Integrations groups
		assignedVisitPoints() {
			return this.$store.state.moduleVisitPoint.assignedVisitPoints;
		},
		assignedVisitPointsFilter() {
			return this.$store.state.moduleVisitPoint.assignedVisitPoints;
		},
		searchOptions() {
			return [
				{value: "Name", label: this.$t("Name")},
				{value: "Identification", label: this.$t("Identification")},
				{value: "Address", label: this.$t("Address")},
				{value: "City", label: this.$t("City")},
				{
					value: "AdditionalFields",
					label: this.$t("Object.AdditionalFields"),
				},
			];
		},
		additionalOptions() {
			return this.dataSelect.category;
		},
		getCheckedVisitPoints() {
			return this.$store.state.moduleVisitPoint.checkedVisitPoits;
		},
		windowWidth() {
			return this.$store.state.windowWidth;
		},
		iconSize() {
			return this.$store.state.windowWidth < 620 ? "small" : "medium";
		},
	},
	methods: {
		openLoading() {
			this.$vs.loading();
		},
		closeLoading() {
			this.$vs.loading.close();
		},
		showPopupVisitPointEmmit() {
			this.visitPointMounted = false;
			this.searchQuery = "";
		},
		removeAssignedVisitPoint(id) {
			this.$store.commit("moduleVisitPoint/REMOVE_ASSIGNED_VISIT_POINT", id);
		},
		searchResource() {
			if (this.$refs.DinamicFields !== undefined && this.searchField.value === "AdditionalFields") {
				// recuperamos todas las propiedades adicionales modificadas desde el componente hijo
				const additional_info = this.$refs.DinamicFields.getAddionalInfo();
				// Formato para buscar por campos adicionales [['property_name', 'property_value']]
				const formatData = Object.entries(additional_info);
				this.$refs.VisitPointList.searchByAdditionalFields(
					[this.additionalField.typology_id],
					formatData,
					1,
					this.exact_values
				);
				return;
			}
			this.$refs.VisitPointList.searchResource2(this.searchField.value, this.searchQuery.trim(), 1);
		},
		refres() {
			this.$refs.VisitPointList.refreshVisitPoint();
			this.searchQuery = "";
			this.searchField = {value: "Name", label: this.$t("Name")};
		},
		getVisitPoint() {
			Commons.openLoadingDiv.call(this, "data-list-visit_point");
			this.$store
				.dispatch("moduleVisitPoint/getVisitPoints", {
					order_by: "added_on",
					sort: "DESC",
					id: this.visit_point_ids,
					assign: true,
				})
				.then((res) => {
					Commons.closeLoadingDiv.call(this, "data-list-visit_point");
					this.$emit("renderMap", true);
					return res;
				})
				.catch((err) => {
					Commons.closeLoadingDiv.call(this, "data-list-visit_point");
					throw new Error(err);
				});
		},
		getAllVisitPoint() {
			this.openLoading();
			this.$store
				.dispatch("moduleVisitPoint/getVisitPoints", {
					order_by: "added_on",
					sort: "DESC",
					assign: true,
				})
				.then(() => {
					this.closeLoading();
					this.visitPointMounted = false;
				})
				.catch((err) => {
					this.closeLoading();
					console.error(err);
				});
		},
		openDeleteAllConfirm() {
			this.$vs.dialog({
				type: "confirm",
				color: "danger",
				title: this.$t("Confirm"),
				text: this.$t("Alarm.DeleteAllText") + ` "${this.$t("VisitPoints")}"`,
				accept: this.deleteAll,
				acceptText: this.$t("Crud.Delete"),
				cancelText: this.$t("Cancel"),
			});
		},
		deleteAll() {
			this.$store.commit("moduleVisitPoint/CLEAR_ASSIGNED_VISIT_POINT");
		},
		async getAdditionalFields() {
			Commons.openLoadingDiv.call(this, "data-list-visit_point");
			const payload = {
				role: [],
				status: [],
				category: "VISIT_POINT",
				typology: [],
			};
			try {
				const response = await this.$store.dispatch(
					"moduleCommon/fetchDataRoleStatusCategoryTypology",
					payload
				);

				if (response.status !== 200) {
					return this.handleError(response.status);
				}
				this.dataSelect = response.data;
				if (this.$store.state.currentModule.meta.module_name === "REPORTS") {
					this.status_id = this.dataSelect.status.map(({id}) => id);
				} else {
					this.status_id = this.dataSelect.status.filter((st) => st.name === "ACTIVE").map(({id}) => id);
				}

				Commons.closeLoadingDiv.call(this, "data-list-visit_point");
			} catch (err) {
				Commons.closeLoadingDiv.call(this, "data-list-visit_point");
				this.throwSpecificError(err);
			}
		},
		handleError(status) {
			if (status === 401) {
				throw new BadRequestError();
			}
			if (status === 500) {
				throw new ServerError();
			}

			if (status === 722) {
				this.$vs.notify({
					color: "danger",
					title: this.$t("Roles.Permissions.NotPermissionsTitle"),
					text: `${this.$t("Roles.Permissions.NotPermissionsText")} ${error.error}`,
					time: 5000,
				});
			}
		},
		throwSpecificError(err) {
			if (err instanceof ServerError || err instanceof NotFoundError || err instanceof NotFoundError) {
				throw err;
			}
			throw new NetworkError();
		},
		getVisitPointSelected() {
			this.$refs.VisitPointList.setAssignedVisitPoint();
		},
		goTo(visitPointId) {
			this.$router.push(`/apps/visit-point/visit-point-view/${visitPointId}`);
		},
	},
	created() {
		if (!moduleVisitPoint.isRegistered) {
			this.$store.registerModule("moduleVisitPoint", moduleVisitPoint);
			moduleVisitPoint.isRegistered = true;
		}
		if (!moduleCommon.isRegistered) {
			this.$store.registerModule("moduleCommon", moduleCommon);
			moduleCommon.isRegistered = true;
		}
	},
	mounted() {
		this.searchQuery = "";
		this.getAdditionalFields();
		if (this.visit_point_ids && this.visit_point_ids.length > 0 && this.assignedVisitPoints.length <= 0) {
			this.getVisitPoint();
		}
		this.exact_values = this.$store.state.modulePreferences.filter_exact_values;
	},
	beforeDestroy() {
		if (this.$store.state.currentModule.name !== "app-resource-view") {
			this.$store.commit("moduleVisitPoint/CLEAR_ASSIGNED_VISIT_POINT");
		}
	},
	watch: {
		searchField(val) {
			if (val.value !== "AdditionalFields") {
				this.additionalField = null;
				return;
			}
			this.getAdditionalFields();
		},
		additionalField(obj) {
			if (obj) {
				this.additional_info = {};
				let dataFields = obj.json_properties;
				dataFields = dataFields.filter((element) => element.name !== "additional_info");
				const updateData = dataFields.map((element) => {
					return {...element, error: false};
				});
				this.model = [...updateData.filter(({additional}) => additional)];
			}
		},
		visitPointMounted(val) {
			if (!val) {
				this.additional_info = null;
				this.model = null;
				this.additionalField = null;
				this.refres();
			}
		},
	},
};
</script>

<style lang="scss" scoped>
#resource-create-tab-info {
	height: 100%;
}

.scroll-area {
	margin: auto;
	width: 100%;
	min-height: 450px;
	max-height: 400px;
}

.content-form-create {
	width: 100%;
	min-height: 550px;
	max-height: 650px;
}

.ag-grid-table {
	@media screen and (max-height: 800px) {
		height: 290px;
	}
}

.custom-height-report {
	height: 70vh;
	border: 1px solid #e4e4e4;
	border-radius: 10px;
	box-shadow: none;
	padding: 20px;
}

.custom-height {
	height: 92vh;
}
</style>
